export default "__VITE_ASSET__DxQWRrfj__"